import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import MaterialTable from "material-table";
import moment from 'moment';
import numeral from 'numeral';
import {Link} from 'react-router-dom'
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Warning from '@material-ui/icons/Warning';
import Error from '@material-ui/icons/Error';
import Face from '@material-ui/icons/Face';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { BACKGROUND_COLOR, BLACK_COLOR, BLUE_COLOR, RED_COLOR, V2_ACTIVE_COLOR, V2_BLACK_COLOR, V2_INACTIVE_COLOR } from '../config/color';
import CanvasJSReact from '../config/canvas/canvasjs.react';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import {seller} from '../config/api';

import {Line} from 'react-chartjs-2';
import { Rotate90DegreesCcw } from '@material-ui/icons';

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;


const ImageContainer = styled.div`
  width: 2rem;
  /* height: 3rem; */
  margin-right: .7rem;
`

const MainSectionTitle = styled.p`
  font-weight: 600;
  color: ${BLACK_COLOR};
  font-size: 0.73rem;
`;

const MainSectionSubTitle = styled.p`
  font-weight: 400;
  color: ${BLACK_COLOR};
  font-size: 0.73rem;
  margin-top: 5px;
`;


const PriceText = styled.p`
  font-weight: 400;
  /* color: #77838f !important; */
  margin-right: 10px;
  color: ${BLACK_COLOR};
  font-size: 0.73rem;
`;

const ComparisonColor = styled.p`
  font-weight: 400;
  /* color: #77838f !important; */
  color: ${props => (props.color > 0 ? `${RED_COLOR}` : props.color === 0 ? `${BLACK_COLOR}` : `${BLUE_COLOR}`)} ;
  font-size: 0.73rem;
`;

const DataTableWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const DataTablePriceWrap = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const DataTableHighAndLowPriceWrap = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 575px) {
    flex-direction: row;
  }
`

const DataTableMedianPriceWrap = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 575px) {
    flex-direction: row;
    margin-top: 10px;
  }
`

const DetailPanelWrap = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 575px) {
    padding: 10px;
  }
`

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Error: forwardRef((props, ref) => <Error {...props} ref={ref} />),
  Face: forwardRef((props, ref) => <Face {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  Warning: forwardRef((props, ref) => <Warning {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  ExitToAppIcon: forwardRef((props, ref) => <ExitToAppIcon {...props} ref={ref} />),
  
};

const columns = [
  {
    title: "브랜드",
    field: "sellerItem.Item.category2",
  },
  {
    title: "모델명",
    field: "sellerItem.Item.name",
  },
  {
    title: "모델",
    field: "sellerItem.Item.category3"
  },
  {
    title: "가격",
    field: "price",
    render: (rowData) => {
      return (
        <div>
          {rowData?.sellerItem?.price > 0 ? (
            <span>{numeral(rowData?.sellerItem?.price).format('0,0')}원</span>
          ) : (
            <span>가격 문의</span>
          )}
        </div>
      )
    }
  },
  {
    // title: "바로가기",
    field: "url",
    render: (rowData) => {
      return (
        <div>
          <a href={`${rowData?.sellerItem?.url}`} target="_blank">
            <ExitToAppIcon style={{color: `${V2_ACTIVE_COLOR}`}} />
          </a>
        </div>
      )
    }
  },
];

const BlockContainerWrap = styled.div`
  width: 100%;
`;

const BlockContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TextBokx = styled.p`
  font-size: .8125rem;
  width: 2.53906rem;
  height: 2.53906rem;
  padding: 0;
  color: #77838f;
  /* background: rgba(119,131,143,.1); */
  border-radius: 50%!important;
  margin-right: .5rem!important;
`

const BlockTitle = styled.h1`
  font-size: 1.21875rem;
  border-bottom: 1px solid #e7eaf3 !important;
  padding-bottom: 0.75rem !important;
`;

const BlueColor = styled(Link)`
    color: #3498db;
    cursor: pointer;
    font-weight: 600;
`;

const BlockTopArticle = styled.div`
  /* width: 1064px; */
  width: 100%;
  padding-bottom: 0.75rem !important;
`;

const BlockBox = styled.div`
  margin-top: 0.75rem !important;
  box-shadow: 0 0.5rem 1.2rem rgba(189, 197, 209, 0.2);
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #e7eaf3;
  border-radius: 0.5rem;
`;

const BlockBoxTable = styled.div`
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0.75rem;

  .MuiTableFooter-root {
    /* display: none !important; */
  }
  .MuiTableCell-root {
    /* padding: 16px 0; */
  }
`;

const RightMargin = styled.div`
  min-width: 10%;
  max-width: 10%;
  margin-right: 2rem;
  @media (max-width: 575px) {
    min-width: 50%;
    max-width: 50%;
    margin-right: 0;
    margin-bottom: 20px;
  }
`

// Detail

const DetailTopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 1.5rem 3rem;
  border: 5px solid #E7E7E7;
  margin-bottom: 20px;
  @media (max-width: 575px) {
    flex-direction: column;
    padding: 1rem 1rem;
  }
`

const ExtraBoldText = styled.p`
  font-weight: 700;
  color: ${V2_BLACK_COLOR};
  font-size: 16px;
  margin: 0px !important;
`
const BoldText = styled.p`
  font-weight: 600;
  font-size: 16px;
  color: ${V2_INACTIVE_COLOR};
  margin: 0px !important;
`

const DetailPriceText = styled.p`
  font-size: 36px;
  font-weight: 600;
  color: ${V2_ACTIVE_COLOR};
  margin: 0px !important;
`

const DetailPriceTextSmall = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: ${V2_ACTIVE_COLOR};
  padding-bottom: 4px;
  margin: 0px !important;
`

const ItemNameText = styled.p`
  font-weight: 700;
  color: ${V2_INACTIVE_COLOR};
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 30px;
`

export default (props) => {
  const {sellerItemList} = props;
  const [itemInfo, setItemInfo] = useState(null);
  const [itemId, setItemId] = useState(null);
  const today = moment().format('YYYY-MM-DD');

  return (
    <BlockContainerWrap>
      <BlockContainer>
        <BlockTopArticle>
          <BlockBox>
            <BlockBoxTable>
              <MaterialTable
                title="오늘의 가격"
                icons={tableIcons}
                style={{ boxShadow: "none" }}
                columns={columns}
                data={sellerItemList}
                options={{
                  search: true,
                  pageSize: 10,
                  toolbar: false,
                  headerStyle: {
                    // backgroundColor: "#F8FAFD",
                    fontWeight: "bold",
                    color: "#6c757e",
                    paddingTop: 5,
                    paddingBottom: 5,
                    fontSize: 12,
                  },
                  rowStyle: {
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontSize: 12
                  }
                }}
                detailPanel={rowData => {
                  
                  const recentlyMedianPrice = numeral(rowData?.medianPrice[rowData.medianPrice.length - 1]).format('0,0')
                  const recentlyDate = rowData?.dateTrend[rowData?.dateTrend.length - 1];
                  
                  return (
                    <DetailPanelWrap>
                      <DetailTopSection>
                        <RightMargin>
                          <img style={{width: '100%'}} src={rowData?.sellerItem?.itemImage} />
                        </RightMargin>
                        {/* <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', width: '100%'}}>
                          <DetailModelText>
                          </DetailModelText>
                        </div> */}
                        <div style={{marginRight: 20}}>
                          <div style={{display: 'flex', alignItems: 'flex-end'}}>
                            <ItemNameText>
                              {rowData?.name}
                            </ItemNameText>
                          </div>
                          <div style={{display: 'flex', alignItems: 'center', marginBottom: 10}}>
                            <ExtraBoldText>시세</ExtraBoldText>
                            <ExtraBoldText style={{color: `${V2_INACTIVE_COLOR}`}} >&nbsp;&nbsp;|&nbsp;&nbsp;</ExtraBoldText>
                            <BoldText>{recentlyDate} 기준</BoldText>
                          </div>
                          <div style={{display: 'flex', alignItems: 'flex-end'}}>
                            <DetailPriceText style={{fontSize: 36, color: `${V2_ACTIVE_COLOR}`}}>{recentlyMedianPrice}</DetailPriceText>
                            <DetailPriceTextSmall style={{fontSize: 18}}>&nbsp;원</DetailPriceTextSmall>
                          </div>
                        </div>
                        <div style={{padding: 10, border: `4px solid ${V2_INACTIVE_COLOR}`}}>
                          <Line
                            width={280}
                            height={140}
                            data={{
                              labels: rowData.dateTrend,
                              datasets: [
                                {
                                  // label: '평균 시세',
                                  fill: false,
                                  lineTension: 0.1,
                                  backgroundColor: '#56afe4',
                                  borderColor: 'rgba(116, 143, 181, 0.56)',
                                  borderCapStyle: 'butt',
                                  borderDash: [],
                                  borderDashOffset: 0.0,
                                  borderJoinStyle: 'miter',
                                  pointBorderColor: `white`,
                                  pointBackgroundColor: `${V2_ACTIVE_COLOR}`,
                                  pointBorderWidth: 1,
                                  pointHoverRadius: 4,
                                  pointHoverBackgroundColor: `${V2_ACTIVE_COLOR}`,
                                  pointHoverBorderColor: 'rgba(220,220,220,1)',
                                  pointHoverBorderWidth: 1,
                                  pointRadius: 4,
                                  pointHitRadius: 10,
                                  borderWidth: 1,
                                  data: rowData.medianPrice
                                },
                              ]
                            }}
                            options={
                              {
                                layout: {
                                  padding: {
                                    top: 20,
                                  }
                                },
                                legend: {
                                  display: false
                                },
                                scales: {
                                  
                                  xAxes: [{
                                    gridLines: {
                                      drawOnChartArea: false
                                    },
                                    ticks:{
                                      callback:function(label){
                                        var year = label.split("-")[0];
                                        var monthDay = label.split("-")[1]+"/"+label.split("-")[2];
                                        return monthDay;
                                      },
                                      maxRotation: 0,
                                      fontColor: `${V2_INACTIVE_COLOR}`,
                                      fontSize: 10,
                                      fontWeight: 300

                                    },
                                  }],
                                  yAxes: [{
                                    ticks: {
                                      display: false,
                                      // stepSize: 3
                                    },
                                    gridLines: {
                                      // drawOnChartArea: false,
                                      color: "rgba(0, 0, 0, 0)",
                                    }
                                  }]
                                }
                              }
                            }
                          />
                        </div>
                      </DetailTopSection>
                    </DetailPanelWrap>
                  )
                }}
              />
            </BlockBoxTable>
          </BlockBox>
        </BlockTopArticle>
      </BlockContainer>
    </BlockContainerWrap>
  )
}